import { AuthStorageKeys } from '@utils/localStorageAuthUtils.utils';
import { AuthConfigurationV2, ZidConnectionDetails } from '../auth.types';

export const ZID_SCOPE = 'openid';
export const ZID_CLIENT_ID = 'secops.client';

export enum ZidAuthLocalStorageKeys {
  idToken = 'zid.id_token',
  accessToken = 'zid.access_token',
  refreshToken = 'zid.refresh_token',
  session = 'zid.session',
}

export enum ZidAuthSessionStorageKeys {
  oauthState = 'zid.oauth_state',
  postLoginRedirectPath = 'zid.post_login_redirect_path',
  customState = 'zid.custom_state',
}

export enum ZidAuthUrlParams {
  code = 'code',
  state = 'state',
  error = 'error',
  errorDescription = 'error_description',
  idLoginHint = 'id_token_hint',
  postLogoutRedirectUri = 'post_logout_redirect_uri',
}

export const retrieveConnectionDetailsFromAuthConfig = (): ZidConnectionDetails => {
  const authConfigStr = getAuthConfigFromLS();
  const authConfig: AuthConfigurationV2 = JSON.parse(authConfigStr);

  if (
    !authConfig.connectionDetails ||
    !('zidTenantServiceDomain' in authConfig.connectionDetails) ||
    !authConfig.connectionDetails.zidTenantServiceDomain
  ) {
    throw new Error('Authentication configuration is invalid or incomplete for ZID sign-in. Missing ZID tenant domain or client ID.');
  }

  return authConfig.connectionDetails as ZidConnectionDetails;
};

export const getAuthConfigFromLS = () => {
  const authConfigStr = localStorage.getItem(AuthStorageKeys.authConfig);
  if (!authConfigStr) {
    throw new Error('Auth configuration not found.');
  }

  return authConfigStr;
};
